import { XIcon } from "@heroicons/react/outline";
import { StarIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";

const DownloadAppMobile = ({ setDownloadApp }) => {
  const { t } = useTranslation();
  return (
    <div className="md:hidden flex items-center justify-between gap-2 h-16 px-3 py-2 bg-blue-600 text-white text-sm w-full">
      <a
        className="flex items-center justify-between gap-4"
        href="https://s.id/pajakind"
      >
        <div className="bg-white rounded-full p-3 w-12 h-12">
          <img src="/logo192.png" alt="Logo" />
        </div>
        <div className="flex flex-col gap-1">
          <span>{t("Download PajakInd App")}</span>
          <div className="flex text-yellow-500">
            {Array.from({ length: 4 }).map((_, index) => (
              <StarIcon key={index} width={18} />
            ))}
            <div className="relative inline-block w-[18px] h-[18px]">
              <StarIcon
                width={18}
                height={20}
                className="absolute"
                style={{
                  clip: "rect(0px, 9px, 18px, 0px)",
                }}
              />
              <StarIcon
                width={18}
                height={20}
                className="absolute left-0 text-gray-100"
                style={{
                  clip: "rect(0px, 18px, 18px, 9px)",
                }}
              />
            </div>
            <span className="text-white text-[10px] my-auto">(4.5)</span>
          </div>
        </div>
      </a>
      <button
        className="bg-white text-black rounded-full p-1"
        onClick={() => setDownloadApp(false)}
      >
        <XIcon width={16} />
      </button>
    </div>
  );
};

export default DownloadAppMobile;
